import type { OvpClient } from '@bldsoft/cappie/api/ovp'
import type {
  FindListSpecialResponseDto,
  TagFindListResponseDto,
  WebTagFindOneOutputDto,
} from '@bldsoft/ovp-api-types'
import type { API } from '@setplex/tria-api'
import type { AdapterDefaults } from '../../index.h'
import { payload } from '../../result'
import { format } from './format'

export function use(
  client: OvpClient,
  tags: API['tags'],
  _api: API,
  _defaults: AdapterDefaults
): void {
  // GET /api/web/tags/${id}
  tags.base.getOneFx.use(async ({ id, withContentTypes, withSeoMetadata }) => {
    const data = payload<WebTagFindOneOutputDto>(
      await client.get.api.web.tags(id, {
        query: { withContentTypes, withSeoMetadata },
      })
    )

    if (!data) {
      throw new Error('Empty answer in tags.base.getOneFx')
    }

    return format(data)
  })

  // GET /api/web/tags
  tags.base.getManyFx.use(
    async ({
      ids,
      limit,
      offset,
      by = _defaults.sortBy,
      order = _defaults.sortOrder,
      q,
      hasContent,
    }) => {
      const data = payload<TagFindListResponseDto>(
        await client.get.api.web.tags({
          query: {
            ids,
            limit,
            offset,
            sortBy: by,
            sortOrder: order,
            q,
            hasContent,
          },
        })
      )

      if (!data) {
        throw new Error('Empty answer in tags.base.getManyFx')
      }

      return [...(data.results || [])].map(format)
    }
  )

  // GET /api/web/tags/special
  tags.base.getManySpecialFx.use(async ({ limit, offset }) => {
    const data = payload<FindListSpecialResponseDto>(
      await client.get.api.web.tags.special({ query: { limit, offset } })
    )

    if (!data) {
      throw new Error('Empty answer in tags.base.getManySpecialFx')
    }

    return [...(data.results || [])].map(format)
  })
}
